// ConnectionTestResult (API.md §7.10) as words, for S-03 and S-04 Connection.
import type { ConnectionTestResult } from '@pa/api/admin'

export const TEST_ERROR_LABELS: Record<NonNullable<ConnectionTestResult['error']>, string> = {
  timeout: 'PF Keeper did not answer in time',
  connection_refused: 'PF Keeper is not reachable',
  tls_error: "PF Keeper's certificate isn't from the platform CA",
  unauthorized: 'The API key was rejected',
  bad_response: 'PF Keeper sent an unexpected answer',
  pf_not_ready: 'Practice Fusion is not logged in or not ready',
}

export const testSummary = (r: ConnectionTestResult): string =>
  r.error === null ? 'Connection test passed' : `Connection test failed: ${TEST_ERROR_LABELS[r.error]}`
